import { toast, ToastContainer } from "react-toastify";
import auth from "../firebase/auth";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import axiosJwt from "../utils/axiosJwt";

export default function UpdateProfileForm({ data, refetch }) {
  const navigate = useNavigate();

  const { uid, displayName, email } = auth.currentUser;

  const { education, address, phoneNumber, linkedin } = data;

  const handleUpdateProfile = (event) => {
    event.preventDefault();

    const form = event.target,
      formdata = Object.fromEntries(new FormData(form));

    const userData = {
      uid,
      displayName,
      email,
      ...formdata,
    };

    axiosJwt
      .put(`${process.env.REACT_APP_SERVER_ENDPOINT}/users`, userData)
      .then(({ data }) => {
        if (data.modifiedCount || data.upsertedCount || data.matchedCount) {
          toast.success("Updated Profile Successfully");

          refetch();

          form.reset();
        } else {
          toast.error("Couldn't Update Profile");
        }
      })
      .catch((error) => {
        if ([401, 403].includes(error?.response?.status)) {
          signOut(auth);

          localStorage.removeItem("token");

          navigate("/login");
        }

        toast.error("Couldn't Update Profile");
      });
  };

  return (
    <form
      onSubmit={handleUpdateProfile}
      class="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100"
    >
      <ToastContainer />

      <div class="card-body">
        <div class="form-control">
          <label class="label">
            <span class="label-text">Education</span>
          </label>

          <input
            type="text"
            name="education"
            placeholder="education"
            defaultValue={education}
            class="input input-bordered"
          />
        </div>

        <div class="form-control">
          <label class="label">
            <span class="label-text">Street Address</span>
          </label>

          <input
            type="text"
            name="address"
            placeholder="street address"
            defaultValue={address}
            class="input input-bordered"
          />
        </div>

        <div class="form-control">
          <label class="label">
            <span class="label-text">Phone Number</span>
          </label>

          <input
            type="tel"
            name="phoneNumber"
            placeholder="phone number"
            defaultValue={phoneNumber}
            class="input input-bordered"
          />
        </div>

        <div class="form-control">
          <label class="label">
            <span class="label-text">LinkedIn ID URL</span>
          </label>

          <input
            type="url"
            name="linkedin"
            placeholder="linkedin id url"
            defaultValue={linkedin}
            class="input input-bordered"
          />
        </div>

        <div class="form-control mt-6">
          <button class="btn btn-primary">Update Profile</button>
        </div>
      </div>
    </form>
  );
}
